import { useEventListener } from "@vueuse/core";
import { computed, shallowRef, toValue } from "vue";

import { useHostElement } from "#ce/composables/useHostElement";
import { toBoolean } from "#ce/utils/props";

import { useActivatorPopupState } from "./useActivatorPopupState.js";

/** Publishes the panel's latest popup role onto the activator, unless the picker is readonly. */
export function useQuantumSelectPopupState({ readonly, open, slot, enabled }) {
  const report = shallowRef();
  const host = useHostElement();

  function handlePanelRole(event) {
    if (event.target?.getRootNode() !== host?.shadowRoot) {
      return;
    }

    const [reported] = event.detail ?? [];
    report.value = reported ?? undefined;
  }

  function panelRoot() {
    return host?.shadowRoot;
  }

  useEventListener(panelRoot, "update-popup-role", handlePanelRole);

  const popupRole = computed(() => {
    if (toBoolean(toValue(readonly))) {
      return undefined;
    }

    return report.value;
  });

  useActivatorPopupState({
    slot,
    expanded: open,
    popupRole,
    enabled,
  });

  return { popupRole };
}
